import React from 'react';
import { AccountMenus } from '../../Overlays/NewAccountFlyout';
import ActiveOverlayPointerWrapper from '../../Overlays/ContentOverlay/ActiveOverlayPointerWrapper';
import { VictorQaClasses } from '../../../../common/qaIds';

const AccountContent: React.SFC<{}> = () => {
    return (
        <ActiveOverlayPointerWrapper className={VictorQaClasses.headerAccountFlyout}>
            <AccountMenus />
        </ActiveOverlayPointerWrapper>
    );
};

export default AccountContent;
